<template>
  <div>
    <base-modal
      id="copy_modal"
      ref="copy_modal"
      :hide-header="true"
      :hide-footer="true"
      @ok="doCopyWorkAssignment"
    >
      <div class="col-sm-12 nopads px-2">
        <h2 class="editor-header">{{ $t('work_assignment.copy') }}</h2>
        <span>{{ $t('work_assignment.copy_confirm') }}</span>
      </div>
      <div class="col-12">
          <span class="title">
            {{ $t('contracts.copy_contract.copy_attachments') }}
          </span>
          <input
              type="checkbox"
              class="form-check-input mx-2"
              v-model="copyAttachments"
              id="copyAttachmentsCheckbox"
              name="copy-attachments"
          >
      </div>
      <div class="col-12 text-end my-2">
        <button class="btn btn-sm btn-secondary form-button" @click="cancelCopying">
          {{ $t('common.no') }}
        </button>
        <button class="btn btn-success btn-sm form-button" @click="doCopyWorkAssignment">
          {{ $t('common.yes') }}
        </button>
      </div>
    </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import BaseModal from "@/components/BaseModal";
import {restApi} from "@/components/mixins/RestApiMixin";
import {inject} from "vue";
export default {
    name: "WorkAssignmentCopyModal",
    components: {BaseModal},
    mixins: [restApi],
    props: {
        assignmentUpdate: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false,
            copyAttachments: false
        }
    },
    methods: {
        doCopyWorkAssignment() {
            this.loading = true
            this.restAdd(this.workAssignmentUrl+'/'+this.assignmentUpdate.id+'/copy',
                {copy_attachments: this.copyAttachments ? true : null},
                this.copySuccess, this.fail)
        },
        copySuccess: function (data) {
            this.loading = false
            this.$emit('updateSuccess', data)
        },
        fail: function () {
            this.loading = false
            this.$emit('cancel')
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        cancelCopying() {
            this.$emit('cancel')
        },
    }
}
</script>
